import React from 'react'
import { Alert } from 'react-bootstrap'

const AlertFormServerErrors = ({formError}) => {
  return (
    <Alert variant="danger" className="my-3">
      <h6 className="font-weight-bold mb-3">
        Verifica los siguientes campos:
      </h6>
      {
        !Array.isArray(formError.fields_with_errors) ?     
        Object.entries(formError.fields_with_errors).map(([field, errors], index) => (
          <div key={index}>
            <p className="font-weight-bold">{field}</p>
            <ul>
                {errors.map((error, idx) => (
                <li key={`${field}-${idx}`}>{error}</li>
                ))}
            </ul>
          </div>
        )) : 
        formError.fields_with_errors.map((error) => (
          Object.entries(error).map(([field, errors], idx) => (
            <div key={idx}>
              <p className="font-weight-bold">{field}</p>
              <ul>
                  {errors.map((error, idx) => (
                  <li key={`${field}-${idx}`}>{error}</li>
                  ))}
              </ul>
            </div>
          ))
        ))
     }
    </Alert>
  )
}

export default AlertFormServerErrors